import { render, staticRenderFns } from "./XoaQuyenThuocNguoiDungModal.vue?vue&type=template&id=1a099daa&"
import script from "./XoaQuyenThuocNguoiDungModal.vue?vue&type=script&lang=js&"
export * from "./XoaQuyenThuocNguoiDungModal.vue?vue&type=script&lang=js&"
import style0 from "./XoaQuyenThuocNguoiDungModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports